/**
 * ЭТАП 2 — честные 404 от бэка (Lazar lib/errors/contentNotFound.error.ts):
 * код CONTENT_NOT_FOUND означает «запрос верный, но контента нет» — в отличие
 * от INTERNAL_SERVER_ERROR (реальная поломка). Его кидают резолверы товара,
 * акций, каталога, рецептов, новостей, статей; formatError бэка дополнительно
 * маппит в него BAD_USER_INPUT от переполненных id (/product/6767676767676767).
 * REST meta.get на несуществующей странице отвечает HTTP 404 с
 * {error: {code: CONTENT_NOT_FOUND}}.
 */
export const CONTENT_NOT_FOUND = 'CONTENT_NOT_FOUND';

type GqlErrorLike = {
  extensions?: { code?: string } | null;
};

/**
 * GraphQL-ветка: callMethod реджектит МАССИВОМ ошибок
 * ({message, path, extensions}) — ищем код в extensions.
 */
export const isContentNotFoundError = (error: unknown): boolean =>
  Array.isArray(error) &&
  (error as GqlErrorLike[]).some(
    item => item?.extensions?.code === CONTENT_NOT_FOUND
  );
